<template>
  <v-slide-x-transition>
    <v-list-tile v-if="brands.length" class="py-4">
      <v-autocomplete
        v-model="brand"
        clearable
        :items="brands"
        label="Filtro por marca"
        open-on-clear
        prepend-icon="pages"
      />
    </v-list-tile>
  </v-slide-x-transition>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters("valueMapping", ["brands"]),
    brand: {
      get() {
        return this.$store.state.valueMapping.brand;
      },
      set(brand) {
        this.setBrand(brand);
      }
    }
  },
  methods: {
    ...mapMutations("valueMapping", ["setBrand"])
  }
};
</script>
